import React, { useState, useEffect } from 'react';
import { companyService } from '../../../services/companyService';
import { Company } from '../../../types';

const CompaniesPage: React.FC = () => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [watchingCompanies, setWatchingCompanies] = useState<Company[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadCompaniesData();
  }, []);

  const loadCompaniesData = async () => {
    try {
      setIsLoading(true);
      const companiesData = await companyService.getAllCompanies();
      setCompanies(companiesData);
      setWatchingCompanies(companiesData.filter(c => c.isWatching));
    } catch (error) {
      console.error('Erro ao carregar dados de empresas:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleCompanyWatching = async (companyId: string) => {
    try {
      const company = companies.find(c => c.id === companyId);
      if (!company) return;

      const isWatching = watchingCompanies.some(c => c.id === companyId);

      if (isWatching) {
        await companyService.removeFromWatchlist(companyId);
        setWatchingCompanies(prev => prev.filter(c => c.id !== companyId));
      } else {
        await companyService.addToWatchlist(companyId);
        setWatchingCompanies(prev => [...prev, company]);
      }
    } catch (error) {
      console.error('Erro ao atualizar lista de empresas:', error);
    }
  };
  
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen-1/2 gap-4">
        <div className="w-12 h-12 border-4 border-gray-200 border-t-blue-700 rounded-full animate-spin"></div>
        <p>Carregando empresas...</p>
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Minhas empresas</h1>
        <p className="text-lg text-gray-600">
          Monitorando: {watchingCompanies.map(c => c.name).join(', ') || 'Nenhuma empresa'}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {companies.map(company => {
          const isWatching = watchingCompanies.some(c => c.id === company.id);
          return (
            <div
              key={company.id}
              className={`bg-white rounded-xl p-6 shadow-sm border border-gray-200 transition-all duration-200 flex justify-between items-center
                ${isWatching ? 'border-green-500 bg-green-50' : 'hover:-translate-y-0.5 hover:shadow-md'}`}
            >
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-1">{company.name}</h3>
                <span className="text-sm text-gray-600 font-medium">{company.symbol}</span>
              </div>
              <button
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 border border-gray-200 bg-white text-gray-900 cursor-pointer
                  ${isWatching ? 'bg-green-500 text-white border-green-500' : 'hover:bg-gray-100'}`}
                onClick={() => toggleCompanyWatching(company.id)}
              >
                {isWatching ? '✓ Monitorando' : '+ Adicionar'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CompaniesPage;
